export const MAX_CELL_CHARS = 30;

export const defaultFormState = {
  campaign_id: "",
  report_name: "",
  start_date: "",
  end_date: "",
  execution_time: "",
  frequency: "RUN NOW",
  only_form_data: false,
  recipients: "",
};

export const getCurrentUtcHourValue = () =>
  String((new Date().getUTCHours() + 1) % 24);

export const defaultViewResult = {
  campaign_id: "",
  total: 0,
  records: [],
};

export const defaultEditFormData = {
  id: "",
  campaign_id: "",
  report_name: "",
  start_date: "",
  end_date: "",
  execution_time: "",
  frequency: "RUN NOW",
  only_form_data: false,
  recipients: "",
};

export const parseRecipients = (rawValue) =>
  rawValue
    .split(",")
    .map((email) => email.trim())
    .filter(Boolean);

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const findInvalidEmails = (emails) =>
  emails.filter((email) => !EMAIL_REGEX.test(email));

export const recipientsToString = (recipients) =>
  Array.isArray(recipients) ? recipients.join(", ") : "";

export const formatCellValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (Array.isArray(value)) return value.length > 0 ? value.join(", ") : "-";
  return String(value);
};

export const truncateCellValue = (value, max = MAX_CELL_CHARS) => {
  if (value.length <= max) return value;
  return `${value.slice(0, max)}...`;
};

export const normalizeHourValue = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "";
  if (numeric < 0 || numeric > 23) return "";
  return String(Math.trunc(numeric)).padStart(2, "0");
};

export const formatExecutionTimeForPayload = (hourValue) => {
  const hour = normalizeHourValue(hourValue);
  return hour ? `${hour}:00` : "";
};

export const validateScheduleForm = (formData, isOneTime) => {
  if (!formData.campaign_id.trim()) return "Please enter a campaign ID.";
  if (!formData.report_name.trim()) return "Please enter report name.";
  if (!formData.recipients.trim()) return "Please enter at least one recipient email.";
  if (!isOneTime && (!formData.start_date || !formData.end_date)) {
    return "Please select start date and end date.";
  }
  if (!formData.execution_time) return "Please select execution time.";
  if (!normalizeHourValue(formData.execution_time)) {
    return "Execution time hour must be between 0 and 23.";
  }
  if (!isOneTime && new Date(formData.end_date) < new Date(formData.start_date)) {
    return "End date cannot be before start date.";
  }
  return "";
};

export const validateCreateScheduleForm = (formData, isRunNow) => {
  if (!formData.campaign_id.trim()) return "Please enter a campaign ID.";
  if (!formData.report_name.trim()) return "Please enter report name.";
  if (!formData.recipients.trim()) return "Please enter at least one recipient email.";
  if (!isRunNow && (!formData.start_date || !formData.end_date)) {
    return "Please select start date and end date.";
  }
  if (!isRunNow && !formData.execution_time) return "Please select execution time.";
  if (!isRunNow && !normalizeHourValue(formData.execution_time)) {
    return "Execution time hour must be between 0 and 23.";
  }
  if (!isRunNow && new Date(formData.end_date) < new Date(formData.start_date)) {
    return "End date cannot be before start date.";
  }
  return "";
};

export const buildCreatePayload = (formData, isRunNow, recipients) => ({
  action: "create",
  campaign_id: formData.campaign_id.trim(),
  report_name: formData.report_name.trim(),
  ...(!isRunNow && {
    start_date: formData.start_date,
    end_date: formData.end_date,
    execution_time: formatExecutionTimeForPayload(formData.execution_time),
    only_form_data: Boolean(formData.only_form_data),
  }),
  frequency: isRunNow ? "ONCE" : formData.frequency,
  status: "SCHEDULED",
  recipients,
});

export const buildUpdatePayload = (formData, isOneTime, recipients) => ({
  action: "update",
  id: formData.id,
  campaign_id: formData.campaign_id.trim(),
  report_name: formData.report_name.trim(),
  ...(!isOneTime && {
    start_date: formData.start_date,
    end_date: formData.end_date,
    execution_time: formatExecutionTimeForPayload(formData.execution_time),
    only_form_data: Boolean(formData.only_form_data),
  }),
  frequency: isOneTime ? "ONCE" : formData.frequency,
  status: "SCHEDULED",
  recipients,
});
